import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LAYOUT_FEATURE_KEY} from '@app/marketplace/storage/storage.state';
import * as fromStorage from '@app/marketplace/storage/storage.state'

export const locationFeature = createFeatureSelector<fromStorage.AppStorageState>(LAYOUT_FEATURE_KEY);
export const selectTerm = createSelector(
  locationFeature,
  (state: fromStorage.AppStorageState) =>{
    return state.search
 });

export const selectProvider = createSelector(
  locationFeature,
  (state: fromStorage.AppStorageState) =>{
    return state.search?.provider
 });

export const selectSearh= createSelector(
  locationFeature,
  (state: fromStorage.AppStorageState) =>{
    return state.search?.searhTerm
 });
